<div id="chart-component">
  <ng-content select="[chart-title]"></ng-content>
  <div id="chart" class="card card--no-padding">
    <div class="chart__header">
      <ng-content select="[chart-header-left]"></ng-content>
      <div class="chart__header-right">
        <date-picker [defaultPeriod]="defaultPeriod()" (dateRangeChange)="selectDate($event)"></date-picker>
      </div>
    </div>

    <div class="content">
      <ng-content select="[chart-header-info]"></ng-content>
      @if (chartViewMode()) {
        <highcharts-chart
          [Highcharts]="highcharts"
          [constructorType]="'chart'"
          [options]="chartOptions()"
          [update]="false"
          [oneToOne]="true"
          (chartInstance)="setChartInstance($event)"
        ></highcharts-chart>
      } @else {
        <ng-content select="[chart-center]"></ng-content>
      }
    </div>

    <div class="chart__bottom">
      <div class="chart__legend">
        @for (item of legendItems(); track $index) {
          <div
            (click)="toggleLegendItem(item[0])"
            [class.inactive]="isSeriesHidden(item[0])"
            class="chart__legend-item"
          >
            <span class="legend-item-bullet" [style.backgroundColor]="item[1].color"></span>
            <span class="chart__legend-label">{{ item[1].label }}</span>
          </div>
        }
      </div>
      <div class="chart__bottom-right">
        <ng-content select="[chart-footer]"></ng-content>
        <div class="chart__export-button-wrapper" (clickOutside)="onClickedOutside()">
          <div (click)="toggleExportOptions()" class="chart__export-button">
            <svg-icon src="assets/images/icons/icon-export.svg"></svg-icon>
          </div>
          @if (exportOverflowVisible()) {
            <div class="chart__export-overflow">
              <div class="chart__export-overflow-item" (click)="exportAsPNG()">
                {{ "Chart.Export.PNG" | translate }}
              </div>
              <div class="chart__export-overflow-item" (click)="exportAsJPG()">
                {{ "Chart.Export.JPG" | translate }}
              </div>
              <div class="chart__export-overflow-item" (click)="exportAsCSV()">
                {{ "Chart.Export.CSV" | translate }}
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
